import React, { useState, useImperativeHandle, forwardRef } from "react";
import styles from "../styles/SnackAlert.module.css";

const SnackAlert = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState("success"); // Can be 'success' or 'error'

  // This method can be called externally using a ref
  useImperativeHandle(ref, () => ({
    showSnackAlert: (msg, alertType, duration = 1500) => {
      setMessage(msg);
      setType(alertType);
      setVisible(true);
      setTimeout(() => setVisible(false), duration);
    },
  }));

  if (!visible) return null;
  return (
    <div
      className={
        `${styles.snackAlertMessage} ${type === "success" ? styles.success : ""} ${type === "error" ? styles.error : ""}`
      }
      style={{
        left: "50%",
        transform: "translateX(-50%)",
        opacity: visible ? 1 : 0,
        visibility: visible ? "visible" : "hidden",
        zIndex: 1000,
      }}
    >
      {message}
    </div>
  );
});

export default SnackAlert;
